import React from 'react';
import {connect} from 'react-redux';
import makeStyles from '@mui/styles/makeStyles';
import { useLocation, useParams } from 'react-router-dom';
import { Paper } from '@mui/material';
import { theme } from '../../Template3/Template';
import { useCompanyData } from '../contexts/DataContext';
import { useMediaQuery } from '@mui/material';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import { HomeOutlined, DashboardOutlined, ShoppingCartOutlined, CallOutlined } from '@mui/icons-material';

const useStyles = makeStyles({
  root: {
    width: '100%',
  },

  iconOnly:{
    opacity: '1 !important'
  },

  activeTab:props=>({
    color: props.activeColor ? props.actionRoot : '#15476d'
  }),

  actionRoot:props=>({
    color: props.defaultColor ? props.defaultColor : '#110729'
  })
});

function MobileNavigation({activeColor,defaultColor,cartList}) {
  const matches = useMediaQuery(theme.breakpoints.up('md'));
  const { data } = useCompanyData();
  const classes = useStyles({activeColor,defaultColor});
  const { companyDomain, t, history } = data || {};
  const {pathname: url} = useLocation();
  const params = useParams();
  const { id: pathId } = params;

  const groupId = cartList.length > 0 ? cartList[0].groupId : '';
  const companyId = cartList.length > 0 ? cartList[0].companyId : '';


  const redirectBooking = () => {
    const groupId = cartList.length > 0 ? cartList[0].groupId : '';
    const companyId = cartList.length > 0 ? cartList[0].companyId : '';
    if(companyId && groupId) history.push(`/booking/${companyId}/${groupId}`)
  }

  if(!matches)
  return (
    <Paper style={{ position: 'fixed', bottom: 0, left: 0, right: 0,zIndex:100 }} elevation={3}>
        <BottomNavigation
            showLabels={true}
            className={classes.root}
        >
          <ActionTab label={t && t('companyPage.home')} t={t} icon={<HomeOutlined />} to={companyDomain ? '/' : `/${pathId}`} history={history} activeColor={activeColor} defaultColor={defaultColor} />
          <ActionTab label={t && t('companyPage.services')} t={t} icon={<DashboardOutlined />} to={companyDomain ? '/temp/services' : `${pathId}/temp/services`} history={history} activeColor={activeColor} defaultColor={defaultColor} />
          <ActionTab label={'Cart'} t={t} icon={<ShoppingCartOutlined />} to={groupId && companyId ? `/booking/${companyId}/${groupId}` : companyDomain ? '/' : `/${pathId}`} history={history} activeColor={activeColor} defaultColor={defaultColor} />
          <ActionTab label={t && t('companyPage.contact')} icon={<CallOutlined />} t={t} to={companyDomain ? `/temp/contact` : `${pathId}/temp/contact`} history={history} activeColor={activeColor} defaultColor={defaultColor} />
        </BottomNavigation>
    </Paper>
  );

  return null;
};

const mapStateToProps = state => {
  return {
    cartList: state.cartList,
  }
};

export default connect(mapStateToProps,null)(MobileNavigation);

const ActionTab = ({icon,label,to, history,activeColor,defaultColor,clickEvent,clickType}) => {
  const classes = useStyles({activeColor,defaultColor});
  const location = useLocation();

  const isActive =
    location.pathname === to ||
    (location.pathname.search('/services') !== -1 &&
    to.search('/services') !== -1);
  return(
    <BottomNavigationAction onClick={clickType ? clickEvent : ()=> history.push(to)} label={label} icon={icon} classes={{iconOnly:classes.iconOnly,root: isActive ? classes.activeTab : classes.actionRoot}} />
  )
};